<dialog #modalElement [id]="modalId" class="modal">
  <div [class]="modalBoxClasses">
    <!-- Header -->
    @if (title || showCloseButton) {
      <div class="flex justify-between items-center mb-4">
        @if (title) {
          <h3 class="font-bold text-lg">{{ title }}</h3>
        }
        @if (showCloseButton) {
          <button
            type="button"
            class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
            (click)="close()"
            aria-label="Close">
            ✕
          </button>
        }
      </div>
    }

    <!-- Body -->
    <div class="modal-content">
      <ng-content></ng-content>
    </div>

    <!-- Footer (optional, via content projection) -->
    <div class="modal-action">
      <ng-content select="[modal-footer]"></ng-content>
    </div>
  </div>

  <!-- Backdrop -->
  @if (closeOnBackdrop) {
    <form method="dialog" class="modal-backdrop">
      <button type="button" (click)="close()">close</button>
    </form>
  }
</dialog>

